import { UAParser } from 'ua-parser-js';

const userAgent = new UAParser();

export function isSafariBrowser() {
  const browser = userAgent.getBrowser();
  return browser.name === 'Safari' || browser.name === 'Mobile Safari';
}

export function isIPhoneOrIPad() {
  const device = userAgent.getDevice();
  return device.vendor === 'Apple' && (device.model === 'iPhone' || device.model === 'iPad');
}
